import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { UrlUtil } from "app/utils/url.util";
import { CommonUtil } from "app/utils/common.util";
import { of } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { LocalstorageService } from "@core/services/localstorage.service";
import { TranslateService } from "@ngx-translate/core";

@Injectable({ providedIn: "root" })
export class UserManagementService {
  constructor(
    private http: HttpClient,
    private urlUtil: UrlUtil,
    private commonUtil: CommonUtil,
    private localStorage: LocalstorageService,
    private _translateService: TranslateService
  ) {}

  public getUserList() {
    return this.http
      .get(this.urlUtil.getUrl("user", "getAll").replace("$ORGANISATION_ID", this.commonUtil.getUserDetail("organisationId")))
      .pipe(
        map((resp: any) => {
          if (resp instanceof Array) {
            return resp;
          }

          return resp;
        }),
        catchError((e) => {
          console.log("getUserList error =>", e);
          return of([]);
        })
      );
  }

  public getUserById(id: string = null) {
    return this.http.get(this.urlUtil.getUrl("user", "searchById").replace("$ID", id)).pipe(
      map((resp: any) => {
        if (resp instanceof Array) {
          return {
            status: true,
            data: resp
          };
        }

        return resp;
      }),
      catchError((e) => {
        console.log("getUserById error =>", e);
        return of({});
      })
    );
  }

  public searchUserByFields(data) {
    const url = this.urlUtil.getUrl("user", "searchByField");
    return this.http.post(url, data).pipe(
      map((resp: any) => {
        if (resp?.status) {
          return resp.data;
        } else {
          return [];
        }
      }),
      catchError((e) => {
        console.log(e);
        return of([]);
      })
    );
  }

  public addUser(payload) {
    return this.http.post(this.urlUtil.getUrl("user", "add"), payload).pipe(
      map((resp: any) => {
        const { status, jsonData, errorMessage } = resp;
        if (status) {
          return {
            status: status,
            message: this._translateService.instant("DataAddSuccess")
          };
        } else {
          return {
            status: false,
            message: errorMessage || jsonData || this._translateService.instant("FailDataAdd")
          };
        }
      }),
      catchError((e) => {
        console.log(e);
        return of({
          status: false,
          message: this._translateService.instant("FailDataAdd")
        });
      })
    );
  }

  public updateUser(data) {
    return this.http.put(this.urlUtil.getUrl("user", "update").replace("$ID", data.id), data).pipe(
      map((resp: any) => {
        const { status, jsonData, errorMessage } = resp;
        if (status) {
          return {
            status: status,
            message: this._translateService.instant("DataUpdateSuccess")
          };
        } else {
          return {
            status: false,
            message: errorMessage || jsonData || this._translateService.instant("FailDataUpdate")
          };
        }
      }),
      catchError((e) => {
        console.log(e);
        return of({
          status: false,
          message: this._translateService.instant("FailDataUpdate")
        });
      })
    );
  }

  public deleteUser(ids) {
    return this.http.delete(this.urlUtil.getUrl("user", "delete"), { body: ids }).pipe(
      map((resp: any) => {
        const { status, jsonData, errorMessage, data } = resp;
        if (status && ids.length === data.deletedId?.length) {
          return {
            status: status,
            message: this._translateService.instant("DataDeleteSuccess")
          };
        } else {
          return {
            status: false,
            message: errorMessage || jsonData || this._translateService.instant("FailDataDelete")
          };
        }
      }),
      catchError((e) => {
        console.log(e);
        return of({
          status: false,
          message: this._translateService.instant("FailDataDelete")
        });
      })
    );
  }

  public getUserListByPartnerId(id: string = null) {
    return this.http.get(this.urlUtil.getUrl("user", "getAllByPartnerId").replace("$ID", id)).pipe(
      map((resp: any) => {
        if (resp?.status) {
          return resp.data;
        } else {
          return [];
        }
      }),
      catchError((e) => {
        console.log(e);
        return of([]);
      })
    );
  }

  public getPartnersList() {
    return this.http.get(this.urlUtil.getUrl("user", "partners")).pipe(
      map((resp: any) => {
        if (resp?.status) {
          return resp.data;
        } else {
          return [];
        }
      }),
      catchError((e) => {
        console.log("getPartnersList error =>", e);
        return of([]);
      })
    );
  }

  public getAdminsList(orgId) {
    return this.http.get(this.urlUtil.getUrl("user", "admins").replace("$ID", orgId)).pipe(
      map((resp: any) => {
        if (resp?.status) {
          return resp.data;
        } else {
          return [];
        }
      }),
      catchError((e) => {
        console.log("getAdminsList error =>", e);
        return of([]);
      })
    );
  }
}
